import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";
import classes from "./SearchInput.module.css";
import { IoMdClose } from "react-icons/io";

const SearchInput = ({ value, onChange, placeholder, showClose, setisOpen }) => {

  return (
    <div className={`${classes.searchContainer}`}>
      <FiSearch
        className={classes.searchIcon}
      />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={classes.searchInput}
      />
      {showClose && <IoMdClose className={classes.searchIcon} onClick={() => setisOpen(false)}/>}
    </div>
  );
};

export default SearchInput;